import React from "react";

import { LoadingLine, LoadingLineVariant } from "./LoadingLine";

/**
 * Props for the LoadingLines component
 */
export interface LoadingLinesProps {
  /**
   * Number of lines
   */
  num: number;
  /**
   * Width of the elements. Default: random width between 80 and 20%
   */
  width?: string[];
  /**
   * Height of the elements. Default: 1em
   */
  height?: string[];
  /**
   * Changes the color of the loading lines.
   */
  variant?: LoadingLineVariant;
}

/**
 * Consolidate a bunch of lines of random width
 */
export function LoadingLines({
  num,
  width,
  height,
  variant,
}: LoadingLinesProps): React.ReactElement | null {
  if (num === 0) {
    return null;
  }
  const lines = [];

  for (let i = 0; i < num; i++) {
    lines.push(
      <LoadingLine
        key={i}
        width={width?.[i]}
        height={height?.[i]}
        variant={variant}
      />
    );
  }

  return <>{lines}</>;
}
